import { render, staticRenderFns } from "./ScreeningsMap.vue?vue&type=template&id=485dc140"
import script from "./ScreeningsMap.vue?vue&type=script&lang=js"
export * from "./ScreeningsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports